var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: '100%',width:'100%'}),attrs:{"id":"echart-rose"}})
}
var staticRenderFns = []

export { render, staticRenderFns }